import * as React from "react";
import styled, { css } from "../../../styled/index";
const Wrapper = styled("nav") `
  ${({ align }) => align === "left" ?
    css `
       a { margin-right: 18px; }
       a:last-child { margin-right: 0; } 
    ` :
    css `
       a { margin-left: 18px; }
       a:first-child { margin-left: 0; } 
    `};
`;
const Item = styled("a") `
  font-family: ${({ fontType, theme }) => fontType === "body" ? theme.font.body : theme.font.header};
  font-size: ${({ theme }) => theme.font.size + 1}px;
  color: ${({ active, theme }) => active ? theme.colors.primary : theme.top_nav.text_color};
  transition: 0.3s color;
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;
export const TopNavMenu = (props) => (React.createElement(Wrapper, { ...props }, props.items.map((i, k) => (React.createElement(Item, { key: k, ...i },
    !!i.icon && React.createElement("span", { className: i.text ? "m-r-2" : "" }, i.icon),
    i.text)))));
//# sourceMappingURL=nav.js.map